<template>
  <div class="content">
    <ed-title-nav ref="header" :title="$t(&quot;Funding Statement and AP Settings&quot;)">
      <span slot="action">
        <router-link 
          v-if="$routerHistory.hasHistory() &amp;&amp; $route.query[&quot;back-to&quot;]" 
          :to="{ path: $routerHistory.previous().path, hash: &quot;&quot; }">
            <i class="fa fa-long-arrow-left"></i>
            <span>&nbsp; {{ $t('Back') + ' ' + $t('to') + ' ' + $t($route.query['back-to']) }}</span>
        </router-link>
      </span>
    </ed-title-nav>

    <div class="container-fluid">
      <ed-section class="active clear"><br/>
          <div>
            <ed-checkbox
              @click='changeHasFundingInvAndAPSetting'
              :options='useTemplates'
              name='same_day_deposit_check'
              required
            >
            </ed-checkbox>
          </div>
          <div class="col-md-12 no-pad">
            <h4>Funding Addresses</h4>
            <span>
              Addresses below will be shown as the Bill To address in the Funding Statement PDF
            </span>
            <br><br>
            <FundingAddresses />

            <br>

            <h4>AP File Templates</h4>
            <span>
              Below is the current list of AP File templates
            </span>
            <br><br>
            <APFileTemplates />
          </div>
      </ed-section>
    </div>
  </div>
</template>

<script>

import FundingAddresses from './FundingAddresses/index'
import APFileTemplates from './APFileTemplates/index'
import settings from '@/components/_modules/Admin/settings'

export default {
  components: {
    FundingAddresses,
    APFileTemplates
  },

  data() {
    return {
      settings: {},
      settingsCopy: {},
      useTemplates: []
    }
  },

  created() {
    this.settings = this.$user.$.settings // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings)
    this.useTemplates.push({
      label: 'Reduce number of AP File and funding statement emails to recipients based on the AP File Templates and Funding Addresses below',
      status: this.settingsCopy.HasFundingInvAndAPSettings
    })
  },

  methods: {
    updateSettings(values) {
      const companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'))
      const updatedCompanySettings = {
        ...companySettingsCopy,
        CompanySettings: values
      }
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings))
      this.$user.$.settings = values
      return settings.methods.updateSettings.call(this, values)
    },
    changeHasFundingInvAndAPSetting(e) {
      if (!e.status) {
        this.settingsCopy.HasFundingInvAndAPSettings = false
      } else {
        this.settingsCopy.HasFundingInvAndAPSettings = true
      }
      this.saveSettings()
    },
    saveSettings(setting) {
      var payload = {
        isAllowed: this.settingsCopy.HasFundingInvAndAPSettings
      }
      this.api.forms.post(this.api.$.settings.company.fundingInvAndAPSettings, payload)
        .then(r => {
          this.updateSettings(this.settingsCopy)
        }).catch(e => {
          this.settingsCopy = utils.copy(this.settings)
        })
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_modules/FundingInvoiceAndAPSettings/index.vue